module.exports = __webpack_public_path__ + "img/javier.a5b06173.png";